import React, { useState } from "react";
import * as styles from "./Contact.module.scss";

export default () => {
  const [serverState, setServerState] = useState({
    submitting: false,
    status: null,
  });

  const handleServerResponse = (ok, msg, form) => {
    setServerState({
      submitting: false,
      status: { ok, msg },
    });
    if (ok) {
      form.reset();
    }
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    setServerState({ submitting: true });

    // Get reCAPTCHA token
    const token = await window.grecaptcha.execute(
      "6Ld8gXcUAAAAAMuOWbAtnihh5h8N3jR6hoydHy8T",
      { action: "submit" }
    );

    // Send form data and reCAPTCHA token to Formspree
    fetch("https://formspree.io/f/mldewzlr", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: form.email.value,
        name: form.name.value,
        message: form.message.value,
        "g-recaptcha-response": token, // Add the token here
      }),
    })
      .then((response) => {
        if (response.ok) {
          handleServerResponse(true, "شكراً لك . تم إرسال رسالتك بنجاح!", form);
        } else {
          response.json().then((data) => {
            handleServerResponse(
              false,
              data.error || "An error occurred",
              form
            );
          });
        }
      })
      .catch(() => {
        handleServerResponse(
          false,
          "An error occurred while submitting the form.",
          form
        );
      });
  };

  return (
    <>
      <div>
        <div className='col-md-8 mt-5'>
          <h1 className={styles.title}> تواصل معنا</h1>
          <p>
            نحن هنا لمساعدتكم في تحقيق أهدافكم وتقديم حلول مبتكرة تناسب
            احتياجاتكم. لا تترددوا في التواصل معنا اليوم لتكتشفوا كيف يمكننا
            تعزيز نجاحكم الرقمي! فريقنا المتخصص ينتظركم بشغف لتقديم الدعم
            والإجابة على جميع استفساراتكم.
          </p>
          <form onSubmit={handleOnSubmit}>
            <div>
              <input
                type='text'
                name='name'
                className={styles.field}
                id='exampleInputName'
                placeholder='الاسم'
                required='required'
              />
            </div>
            <div>
              <input
                type='email'
                name='email'
                className={styles.field}
                id='exampleInputEmail1'
                aria-describedby='emailHelp'
                placeholder='البريد الالكتروني'
                required='required'
              />
            </div>
            <div>
              <textarea
                className={styles.message}
                name='message'
                id='exampleInputMessage'
                placeholder='كيف يمكننا مساعدتك؟'
                required='required'
              />
            </div>

            <button
              type='submit'
              className={styles.submit}
              disabled={serverState.submitting}
            >
              {serverState.submitting ? (
                <span className={styles.loader}></span>
              ) : (
                "إرسال"
              )}
            </button>
            {serverState.status && (
              <p className={!serverState.status.ok ? "errorMsg" : ""}>
                {serverState.status.msg}
              </p>
            )}
          </form>
        </div>
      </div>
    </>
  );
};
